<template>

  <div>

    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('i18n.apk_update')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('i18n.apk_mange')}}</el-breadcrumb-item>
            <el-breadcrumb-item >
                <span v-on:click="back" size='mini'> {{$t('i18n.apk_version')}}</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item >{{$t('i18n.column.upload_install_package')}}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-container">
      <el-card class="filter-container" shadow="never">
        <span>{{ $t('i18n.span.apk_uploading', { apkName: apkName, versionNo: versionNo }) }}</span>
        <div style="margin-top: 15px">
        </div>
      </el-card>
    </div>
    <uploader browse_button="browse_button" :url="server_config.url+'/BigFile/'" chunk_size="2MB" :max_retries="1" :filters="{prevent_duplicates:true}" :FilesAdded="filesAdded" :BeforeUpload="beforeUpload" :Error="error" :UploadComplete="uploadComplete" :FileUploaded="fileUploaded" @inputUploader="inputUploader" />
    <br/>
    <br/>
    <el-button type="primary" round id="browse_button">{{$t('i18n.choose_file')}}</el-button>
    <el-button :disabled="uploading" type="primary" round @click="uploadStart()">{{$t('i18n.upload_start')}}</el-button>
    <el-button :disabled="!uploading" type="warring" round @click="uploadStop()">{{$t('i18n.upload_pause')}}</el-button>
    <br/>
    <el-table :data="tableData" style="width: 100%; margin: 10px 10px;">
      <el-table-column :label="$t('i18n.column.file_name')">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('i18n.column.file_size')">
        <template slot-scope="scope">
          <span>{{scope.row.size}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('i18n.column.current_status')">
        <template slot-scope="scope">
          <span v-if="scope.row.status === -1">{{$t('i18n.loading_data')}}</span>
          <span v-if="scope.row.status === 1 && scope.row.percent === 0" style="color: orange">{{$t('i18n.loading_ok_upload')}}</span>
          <span v-if="scope.row.status === 4" style="color: brown">{{$t('i18n.upload_fail')}}</span>
          <span v-if="scope.row.status === 5" style="color: blue">{{$t('i18n.upload_ok')}}</span>
          <el-progress v-if="scope.row.status === 2 || scope.row.status === 1 && scope.row.percent > 0" :text-inside="true" :stroke-width="20" :percentage="scope.row.percent"></el-progress>
        </template>
      </el-table-column>
      <el-table-column :label="$t('i18n.column.operator')">
        <template slot-scope="scope">
          <el-button type="danger" round @click="deleteFile(scope.row.id)">{{$t('i18n.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br/>

  </div>
</template>

<script>
import FileMd5 from '@/models/file-md5.js';
import Uploader from '@/components/upload/Uploader';
import { updateApkVersion } from '@/api/apkVersion';
export default {
    name: 'ApkUpload',
    data() {
        return {
            server_config: this.global.server_config,
            up: {},
            files: [],
            tableData: [],
            uploading: false,
            apkName: '',
            versionNo: '',
            updateApkVersion: {
                apkVersionId: null,
                status: null,
                fileName: null,
                fileSize: null,
                downloadUrl: null
            }
        };
    },
    components: {
        uploader: Uploader
    },
    watch: {
        files: {
            handler() {
                this.tableData = [];
                this.files.forEach(e => {
                    this.tableData.push({
                        name: e.name,
                        size: e.size,
                        status: e.status,
                        id: e.id,
                        percent: e.percent
                    });
                });
            },
            deep: true
        }
    },
    created() {},

    activated() {
        this.getParam(); //重新调用加载函数
    },
    methods: {
        back() {
            this.$router.go(-1); //返回上一层
        },
        inputUploader(up) {
            this.up = up;
            this.files = up.files;
        },
        removeAllFile() {
            this.up.files.forEach(f => {
                this.deleteFile(f.id);
            });
        },
        filesAdded(up, files) {
            files.forEach(f => {
                f.status = -1;
                FileMd5(f.getNative(), (e, md5) => {
                    f['md5'] = md5;
                    f.status = 1;
                });
            });
        },
        deleteFile(id) {
            let file = this.up.getFile(id);
            this.up.removeFile(file);
        },
        beforeUpload(up, file) {
            up.setOption('multipart_params', { size: file.size, md5: file.md5 });
        },
        uploadStart() {
            this.uploading = true;
            this.up.start();
        },
        uploadStop() {
            this.uploading = false;
            this.up.stop();
        },
        error() {
            this.uploading = false;
        },
        uploadComplete() {
            this.uploading = false;
            console.log('上传后回调', this.tableData[0].status);
            if (this.tableData[0].status === 5) {
                this.handleUpdateVersion();
            } else if (this.tableData[0].status === 4) {
            }
        },
        //每个次切片文件上产返回值
        fileUploaded(up, files, info) {
            var res = JSON.parse(info.response);
            if (res.code === 0 && res.data != null) {
                this.updateApkVersion.downloadUrl = res.data;
                console.log('上传文件返回URL', res.data);
            }
        },
        //其他页面跳转过来的参数
        getParam() {
            var param = this.$route.query;
            this.updateApkVersion.apkVersionId = param.apkVersionId;
            this.versionNo = param.versionNo;
            this.apkName = param.apkName;
            console.log('上传文件接收的参数', param);
        },
        async handleUpdateVersion() {
            (this.updateApkVersion.status = 2), (this.updateApkVersion.fileName = this.tableData[0].name);
            var num = this.tableData[0].size / 1024 / 1024;
            var flag = false;
            if (num < 0.01) {
                flag = true;
                num = this.tableData[0].size / 1024;
            }
            this.updateApkVersion.fileSize = num.toFixed(2) + '' + (flag == true ? 'Kb' : 'M');
            console.log('updateApkVersion', this.updateApkVersion);
            const { data: res } = await updateApkVersion(this.updateApkVersion);
            console.log('更新文件', res);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            } else {
                this.removeAllFile();
                this.back();
            }
            this.tableData = [];
        }
    }
};
</script>

<style scoped>
</style>
